/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ObservableMap } from "mobx";

import { MultiSelectState } from "./MultiSelectState";

/**
 * Creates a state for selecting multiple entities using generic store.
 * Creates an empty ObservableMap for selected entities.
 * @returns The created state for selecting multiple entities using generic store.
 */
export function createMultiSelectState<TKey, TEntity>(): MultiSelectState<TKey, TEntity> {
    return {
        selectedValues: new ObservableMap<TKey, TEntity>()
    };
}